// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"063cebb7","453":"8cb221e1","455":"61369105","644":"5a5ddd82"}[chunkId] + ".chunk.js";
};